@let galleryLabel = label();
@if(galleryLabel && (!readonly() || documents().length > 0 || files().length > 0)) {
<ion-label class="gallery-label">{{ galleryLabel }}</ion-label>
}

<div class="gallery-container">
	<ion-button class="left-button" fill="clear" size="big" (click)="moveLeft()"
		[hidden]="observableHidLeftBtn.value$ | async">
		<ion-icon name="chevron-back-outline"></ion-icon>
	</ion-button>

	<drag-scroll #dragScroll [ngClass]="isMobile ? '' : 'web-drag-scroll'"
		(reachesLeftBound)="leftBoundStat($any($event))" (reachesRightBound)="rightBoundStat($any($event))"
		[snap-offset]="10">
		@if(!readonly()) {
		<div drag-scroll-item (click)="presentPopOver($event)" class="document-ctn">
			<div class="add-document">
				<ion-icon name="add-circle"></ion-icon>
				<span class="document-name ellipsis-2">AJOUTER UN DOCUMENT</span>
			</div>
		</div>
		}
		@for(file of files().slice().reverse(); track file.guid;) {
		<div drag-scroll-item class="document-ctn" (click)="sendGallery.openFileAt(files().length - 1 - $index)">
			@if(!readonly()) {
			<ion-button class="remove-button" fill="clear" size="small"
				(click)="$event.stopPropagation(); sendGallery.deleteItem(files().length - 1 - $index, false, false)">
				<ion-icon name="close" slot="icon-only"></ion-icon>
			</ion-button>
			}
			@if(isImage(file)) {
			<calao-document-image-preview [file]="file.file"></calao-document-image-preview>
			}
			@else {
			<div class="document">
				<ion-icon name="document"></ion-icon>
				<span class="document-name ellipsis-2">{{ file.name }}</span>
			</div>
			}
		</div>
		}
		@for(document of documents(); track document._id;) {
		<div drag-scroll-item (click)="openDocumentAsync(document)" class="document-ctn">
			@if(!readonly()) {
			<ion-button class="remove-button" fill="clear" size="small"
				(click)="$event.stopPropagation(); onRemoveDocumentClickedAsync(document)">
				<ion-icon name="close" slot="icon-only"></ion-icon>
			</ion-button>
			}
			@if(isImage(document)) {
			<calao-document-image-preview [guid]="getImageGuid(document)"></calao-document-image-preview>
			} @else {
			<div class="document">
				<ion-icon [name]="document.icon"></ion-icon>
				<span class="document-name ellipsis-2">{{ document.name }}</span>
			</div>
			}
		</div>
		}
	</drag-scroll>

	<ion-button class="right-button" fill="clear" size="big" (click)="moveRight()"
		[hidden]="observableHidRightBtn.value$ | async">
		<ion-icon name="chevron-forward-outline"></ion-icon>
	</ion-button>

	<div [hidden]="true">
		<gallery #sendGallery (onFilesChanged)="onFilesChanged($event)" [filePickerVisible]="false" [files]="files()"
			[command$]="galleryCommand$" [cameraButtonVisible]="false" [acceptedFiles]="galleryAcceptFiles"></gallery>
	</div>
</div>